module.exports = __webpack_public_path__ + "static/media/wizualizacja-42.85036b91.png";